<h2>Import Preview</h2>
<div class="example-container mat-elevation-z2">
  <form [formGroup]="form">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows>
      <ng-container
        *ngFor="let column of config"
        [cdkColumnDef]="column.property"
      >
        <mat-header-cell *cdkHeaderCellDef>{{ column.header }}</mat-header-cell>
        <mat-cell *cdkCellDef="let row; let idx = index;">
          <span
            [class.strong]="column.property == 'firstName' || column.property == 'lastName'"
          >
            {{ row[column.property] }}
          </span>
        </mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="action">
        <mat-header-cell *cdkHeaderCellDef>Action</mat-header-cell>
        <mat-cell *cdkCellDef="let row; let idx = index;">
          <button
            (click)="removeAt(idx)"
            *ngIf="!results"
            [disabled]="loading"
            role="button"
            color="warn"
            mat-button
          >
            Remove
          </button>
        </mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="result">
        <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
        <mat-cell
          class="result-cell"
          *cdkCellDef="let row; let idx = dataIndex;"
        >
          <ca-row-result
            *ngIf="results"
            [ok]="!results[idx]?.hasErrors"
            [result]="results[idx]"
            [messages]="{ ok: 'Imported OK', error: flattenError(results[idx]), locationOk: 'Found Location', locationError: 'Could not find location' }"
          ></ca-row-result>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="familyEmails">
        <mat-cell *matCellDef="let element" [attr.colspan]="config.length+2">
          <h5>Family Invites:</h5>
          <mat-chip-list>
            <mat-chip *ngIf="element.family_Email"
              >{{ element.family_Email}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email1"
              >{{ element.family_Email1}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email2"
              >{{ element.family_Email2}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email3"
              >{{ element.family_Email3}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email4"
              >{{ element.family_Email4}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email5"
              >{{ element.family_Email5}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email6"
              >{{ element.family_Email6}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email7"
              >{{ element.family_Email7}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email8"
              >{{ element.family_Email8}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email9"
              >{{ element.family_Email9}}</mat-chip
            >
            <mat-chip *ngIf="element.family_Email10"
              >{{ element.family_Email10}}</mat-chip
            >
          </mat-chip-list>
        </mat-cell>
      </ng-container>
      <mat-header-row
        *cdkHeaderRowDef="displayedColumns | async"
      ></mat-header-row>
      <mat-row
        *cdkRowDef="let row; columns: (displayedColumns | async);"
        (click)="expandedRow = expandedRow === row ? null : row"
      >
      </mat-row>
      <mat-row
        *matRowDef="let row; columns: ['familyEmails']"
        class="example-detail-row"
      ></mat-row>
    </mat-table>
  </form>
</div>
